
import React, { useState, useEffect } from 'react';
import { editFee, deleteFee } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const EditFeeModal = ({ closeModal, refreshData, fee }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (fee) {
            setName(fee.name);
            setDescription(fee.description);
            setAmount(fee.amount / 100);
        }
    }, [fee]);

    const handleEdit = async () => {
        try {
            const payload = {
                id: fee.id,
                name,
                description,
                amount: parseFloat(amount) * 100
            };

            await editFee(payload);
            closeModal();
            refreshData();
        } catch (error) {
            const message = mapErrorMessage(error.message);
            setErrorMessage(message);
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Are you sure you want to delete this fee?')) {
            try {
                await deleteFee(fee.id);
                closeModal();
                refreshData();
            } catch (error) {
                const message = mapErrorMessage(error.message);
                setErrorMessage(message);
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button onClick={closeModal} className="modal-close">&times;</button>
                <h2>Edit Fee</h2>
                {errorMessage && <p className="error">{errorMessage}</p>}
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Description"
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="number"
                        placeholder="Amount"
                        value={amount}
                        onChange={e => setAmount(e.target.value)}
                    />
                </div>
                <div className="actions-centered">
                    <button onClick={closeModal} className="cancel-button text-button">Cancel</button>
                    <button onClick={handleEdit} className="submit-button text-button">Save Changes</button>
                    <button onClick={handleDelete} className="submit-button text-button">Delete</button>
                </div>
            </div>
        </div>
    );
};

export default EditFeeModal;
